import PropTypes from 'prop-types';

const expenseTeamReport = PropTypes.shape({
  totalCount: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
});

export default expenseTeamReport;
